import fireplace from "./fireplace.jsx";
import portal from "./portal.jsx";
import tree from "./xmas-tree.jsx";
import door from "./door.jsx";

export default {
  fireplace,
  portal,
  "xmas-tree": tree,
  door,
};
